<template>
  <div id="app" ref="myScrollbar">
    <router-view :key="key"/>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      toggle: false,
    };
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    },
  },
  created() {},
  mounted() {},
};
</script>

<style>
body {
  margin: 0px;
  color: #757763;
  background: #ffffff;
  font-family: Quicksand, sans-serif;
  line-height: 1.5;
}
blockquote,
body,
dd,
dl,
dt,
fieldset,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
html,
iframe,
legend,
li,
ol,
p,
pre,
textarea,
ul {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.mr-2 {
  margin-right: 0.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue